module.exports = __webpack_public_path__ + "static/media/IMG-20151107-WA000.c89bbea9.jpg";